module.exports = __webpack_public_path__ + "static/media/farnaz.d92de4f5.jpg";